import { useConfig } from "../../../contexts/ConfigContext"
import React, { useEffect, useState } from "react"
import { Button, TableColumnsType } from "antd"
import DataViewList from "../DataViewList"
import useAuth from "../../../hooks/useAuth"
import { ColumnType } from "antd/es/table"
import { SearchOutlined, PlusOutlined } from "@ant-design/icons"
import { useStore } from "../../../contexts/StoreContext"
import StoreModal from "../../modals/StoreModal"
import { useStoreFetch } from "../../../hooks/useInventory"
import { useCompany } from "../../../contexts/CompanyContext"

function ViewStoreItemList(){
  const { config } = useConfig()
  const {store,updateStore} = useStore()
  const {company} = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data} = useStoreFetch(tokenData,{
    all:true,
    company:company.current.uid
  })
  useEffect(()=>{
    if(data?.storehouse){
      updateStore({list: data.storehouse})
      setSkeleton(false)
    }
  },[data,store.current])
  //console.log('Load content ',companies.current)
  let title = 'Almacenes'
  let emptyMessage = 'Aun no has agregado almacenes'

  const handleClick = async (data:any,index:any) => {
    setSpinning(true)
    updateStore({showModal:true,current:data})
    setSpinning(false)
  }

  // Columnas de la tabla con búsqueda
  const filterIconElement = (filtered:boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  const getColumnSearchProps = (dataIndex: string): ColumnType => ({
    filterIcon: filterIconElement,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toString().toLowerCase())
  });

  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register",width:50},
    {title: "Nombre",dataIndex:"name",ellipsis:true,
      sorter:(a,b)=>a.name.localeCompare(b.name),
      ...getColumnSearchProps('name')},
    {title: "ID",dataIndex:"alias",ellipsis:true,
      sorter:(a,b)=>a.description.localeCompare(b.description),
      ...getColumnSearchProps('alias')},
    {title: "Creado",dataIndex:"created_at",render:(text)=>new Date(text).toLocaleString()},
  ]

  const dataTable = store?.list?.map((el:any,i:number)=>{
    el.register = i + 1
    el.key = i 
    return el
  })
  const handleButtonClick = () => {
    updateStore({showModal:true,current:undefined})
  }
  const headerElement = () => (
    <Button type="primary" icon={<PlusOutlined />} onClick={handleButtonClick} htmlType="button">
      Crear Almacén
    </Button>
  )

  return (
    <DataViewList
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      modal={StoreModal}
      headerElement={headerElement}
      onRow={(data:any,index:any) => {return{onClick:()=>handleClick(data,index),style:{cursor:"pointer"}}}}
      emptyMessage={emptyMessage}>
    </DataViewList>
  )
}

export default ViewStoreItemList